// HOOKS
import useGetManyCustomers from "../../../../hooks/customers/useGetMany.customer";
// CONTEXTS

// COMPONENTS
import TableSearchSelection from "../tableSearch.selection.input";

const CustomerSearchSelection = ({ value, handleChange = () => {} }) => {
  const { customers, handleSearch } = useGetManyCustomers();
  return (
    <TableSearchSelection
      value={value}
      options={customers}
      onChange={handleChange}
      handleSearch={handleSearch}
      name="business_name" // Field that is shown and searched
    />
  );
};

export default CustomerSearchSelection;
